import type { Plugin } from "../core/plugin";
import { PluginRegistry } from "../core/pluginRegistry";

class TktWidgetB2BHeader implements Plugin {
  private actionHandler = (event: Event) => {
    const target = (event.target as HTMLElement).closest<HTMLElement>(
      "[data-action]",
    );
    if (!target || !this.element.contains(target)) return;

    const action = target.dataset.action;

    if (action === "expand") {
      const expanded = target.getAttribute("aria-pressed") === "true";
      target.setAttribute("aria-pressed", String(!expanded));
      this.element.classList.toggle("is-expanded", !expanded);
    }

    this.element.dispatchEvent(
      new CustomEvent(`tktWidgetB2BHeader:${action}`, {
        bubbles: true,
        detail: { action },
      }),
    );
  };

  constructor(private element: HTMLElement) {}

  init(): void {
    this.element.addEventListener("click", this.actionHandler);
  }

  destroy(): void {
    this.element.removeEventListener("click", this.actionHandler);
  }
}

PluginRegistry.register("tktWidgetB2BHeader", TktWidgetB2BHeader);
